<template>
  <div class="bx-footer__abo-teaser bx-form bx-typo--form">
    <div class="bx-footer__abo-teaser-image">
      <img :src="coverImageUrl('tvmovie', 180)"
           loading="lazy"
           width="2"
           height="3"
           data-pin-nopin="true"
           alt="Cover der aktuellen Ausgabe von TV Movie"
           title="Cover der aktuellen Ausgabe von TV Movie">
    </div>
    <div class="bx-footer__abo-teaser-inner-wrapper">
      <span class="bx-footer__abo-teaser-headline">
        Das aktuelle TV&nbsp;Movie&nbsp;Heft
      </span>
      <a class="bx-form__button"
         target="_blank"
         rel="noopener"
         href="https://www.bauer-plus.de/tv-movie/">
        Jetzt abonnieren!
      </a>
    </div>
  </div>
</template>

<script>
import { useCoverImage } from '../../../composables/use-cover-image'

export default {
  setup() {
    const { coverImageUrl } = useCoverImage()
    return { coverImageUrl }
  }
}
</script>
